const loadItems = (() => {
  let isLoading = false;

  function getInputs() {
    return {
      nextUrlInput: document.querySelector("input[data-next-url]"),
      totalPagesInput: document.querySelector("input[data-total-pages]"),
      currentPageInput: document.querySelector("input[data-current-page]"),
    };
  }

  function parseIntSafe(v, fallback = 0) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function buildUrlForPage(baseUrl, pageNumber) {
    // baseUrl può essere relativo ("/collections/...?page=2") o assoluto
    const url = new URL(baseUrl || window.location.href, window.location.origin);
    url.searchParams.set("page", String(pageNumber));
    return url.toString();
  }

  return (button) => {
    if (isLoading) return;
    isLoading = true;

    const { nextUrlInput, totalPagesInput, currentPageInput } = getInputs();

    const totalPages = parseIntSafe(totalPagesInput?.value, 1);
    let currentPage = parseIntSafe(currentPageInput?.value, 1);

    // Se siamo già all’ultima pagina, elimina il bottone e stop
    if (currentPage >= totalPages) {
      button.remove();
      isLoading = false;
      return;
    }

    const targetPage = currentPage + 1;

    // Base URL: usa quello nello snippet (paginate.next.url), fallback alla pagina corrente
    const baseNextUrl = nextUrlInput?.value || window.location.href;

    const requestUrl = buildUrlForPage(baseNextUrl, targetPage);

    button.setAttribute("disabled", "");
    button.classList.add("loading");

    $.ajax({
      url: requestUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        const $resp = $(responseHTML);
        const htmlChunk = $resp.find(".load-more-grid").html();

        // Se Shopify non ci restituisce nuovi prodotti, stop e rimuovi bottone
        if (!htmlChunk || !htmlChunk.trim().length) {
          button.remove();
          return;
        }

        $(".load-more-grid").append(htmlChunk);

        // eventuali init del tema
        if (typeof colorSwatches === "function") colorSwatches();
        if (typeof window.updateShowingText === "function") window.updateShowingText();
      },
      complete: function () {
        // Aggiorna SEMPRE current page
        if (currentPageInput) currentPageInput.value = String(targetPage);
        currentPage = targetPage;

        // Se ci sono altre pagine, prepara next url corretto
        if (currentPage < totalPages) {
          const nextPage = currentPage + 1;
          const nextUrl = buildUrlForPage(baseNextUrl, nextPage);

          if (nextUrlInput) nextUrlInput.value = nextUrl;

          // Supporto infinite scroll: aggiorna anche i campi dentro .infinite-scroll__data se presenti
          const scollData = document.querySelector(".infinite-scroll__data");
          if (scollData) {
            const nextUrlEl = scollData.querySelector("input[data-next-url]");
            const currPageEl = scollData.querySelector("input[data-current-page]");
            if (nextUrlEl) nextUrlEl.value = nextUrl;
            if (currPageEl) currPageEl.value = String(currentPage);

            if (typeof checkVisibility === "function") checkVisibility();
          }

          button.removeAttribute("disabled");
          button.classList.remove("loading");
        } else {
          // Ultima pagina: rimuovi bottone
          button.remove();
        }

        // IMPORTANTISSIMO: reset sempre
        isLoading = false;
      },
      error: function () {
        // fallback di sicurezza
        button.removeAttribute("disabled");
        button.classList.remove("loading");
        isLoading = false;
      },
    });
  };
})();

window.updateShowingText = () => {
  let currentPage = parseInt($("[data-current-page]").val(), 10);
  const totalProducts = parseInt($("[data-total-products]").val(), 10);
  const perPage = $("[data-per-page]").data("per-page");

  if (totalProducts <= perPage) currentPage = 1;

  let text = "products";
  if (totalProducts === 1) text = "product";

  const productsShowing = Math.min(currentPage * perPage, totalProducts);
  const showingText = `Showing ${productsShowing} of ${totalProducts} ${text}`;
  $(".showing-text").text(showingText);
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");

  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(spinner);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
};

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => loadItems(button);
  });

  checkVisibility();
  window.updateShowingText();
}

// Nota: nel vostro file originale loadMore() veniva chiamata 2 volte.
// Teniamola UNA volta su DOMContentLoaded (più section load), così non raddoppia handler/observer.
document.addEventListener("DOMContentLoaded", function () {
  loadMore();
  document.addEventListener("shopify:section:load", function () {
    loadMore();
  });
});
